import Cookies from "js-cookie";
import { settings } from "settings";
import { userStore } from "store/userStore";

const TOKEN_KEY = "token";

export const getToken = () => {
  const token = Cookies.get(TOKEN_KEY);

  return token || "";
};

export const setToken = (token: string) => {
  return Cookies.set(TOKEN_KEY, token);
};

// Kiểm tra quyền theo (path, action). Role admin luôn có toàn quyền.
export const can = (path: string, action: string = "VIEW") => {
  if (!settings.checkPermission) return true;

  const role = userStore.info.role;
  if (role?.isAdmin) return true;

  return !!role?.permissions?.some((e) => e.path === path && (e.action || "VIEW") === action);
};
